import { Box, Divider, Text, useToast, HStack } from "@chakra-ui/react";
import { GoogleLogin } from "@react-oauth/google";
import { ProblemCode } from "@syla/shared/errors/ProblemCode";
import { isSylaApiError } from "@syla/shared/errors/SylaApiError";
import React, { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import { Route, useNavigator } from "../../routers/navigator";
import { shadows } from "../../theme/foundations/shadows";
import { errorToastOptions } from "./errorToastOptions";

// const window = global as any;

export const GoogleSignInForm = (): JSX.Element => {
  const { loginWithGoogle } = useContext(UserContext);
  const toast = useToast();
  const navigate = useNavigator();

  async function handleSuccessfulAuth(credentialResponse: {
    clientId?: string;
    credential?: string;
  }) {
    console.debug({ credentialResponse });
    try {
      const { credential } = credentialResponse;
      if (!credential) {
        throw new Error("credential missing in credentialResponse");
      }

      // router will handle initial redirect
      const { defaultAccountId, newUser } = await loginWithGoogle({
        credential,
      });
      navigate({
        route: newUser ? Route.FirstLogin : Route.Home,
        accountId: defaultAccountId,
        replace: true,
      });
    } catch (error) {
      console.debug("handleSuccessfulAuth error", error);

      if (isSylaApiError(error)) {
        if (error.code === ProblemCode.GoogleAuthFailed) {
          toast({
            ...errorToastOptions,
            title: "Google Sign-In failed",
          });
          return;
        } else if (error.code === ProblemCode.EmailDisallowed) {
          toast({
            ...errorToastOptions,
            title:
              "Google Sign-In failed. The email associated with this Google account is not eligible for an account with Syla",
          });
          return;
        }
      }

      toast({
        ...errorToastOptions,
        title: "Google Sign-In failed. Please try again later",
      });
      return;
    }
  }

  return (
    /* n.b. Use position=relative to anchor the position=absolute child */
    <Box>
      <Box display="inline">
        {/* Anchor for google sign-in button */}
        {/* maxW=185 is used to prevent button from being super wide before it fully loads */}
        {/* n.b. Use position=absolute to prevent divs below from jumping as button loads */}
        <Box
          maxW="185px"
          // override the button styling from the non-chakra component
          sx={{
            '& [role="button"][tabindex="0"]:focus-visible': {
              outline: "none",
              boxShadow: shadows.outline,
            },

            '& [role="button"][tabindex="0"]:focus': {
              outline: shadows.outline,
            },
          }}
        >
          <GoogleLogin
            useOneTap
            use_fedcm_for_prompt
            onSuccess={handleSuccessfulAuth}
            onError={() => {
              toast({
                ...errorToastOptions,
                title: "Google Sign-In failed.",
              });
            }}
          />
        </Box>

        {/* Revoke button, used for debugging */}
        {
          // <Button
          //   onClick={() => {
          //     window.google.accounts.id.revoke(
          //       "bogdan@syla.com.au",
          //       ({ successful }: { successful: boolean }) => {
          //         window.google.accounts.id.disableAutoSelect();
          //         window.alert(successful ? "Revoke success" : "Revoke failed");
          //       },
          //     );
          //   }}
          // >
          //   Revoke
          // </Button>
        }
        {/* n.b. the google button size is 44px */}
        <HStack mt="20px" mb="20px">
          <Divider color="white.1000" />
          <Text>OR</Text>
          <Divider color="white.1000" />
        </HStack>
      </Box>
    </Box>
  );
};
